/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const SelectionCreate = () => {
  const { selectionApi } = apiPath;
  const { selectionContent } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "Name",
      type: "Text",
      name: "title",
      required: false,
    },
    {
      elementType: "textField",
      label: "short description",
      type: "Text",
      name: "short_description",
      required: false,
    },
    {
      elementType: "file",
      label: `Image`,
      name: "image",
      type: "file",
      fullCol: true,
      required: false,
    },
  ];

  const update = async (data) => {
    const { image, ...rest } = data;
    rest.image = {
      url: image,
    };
    rest.slug = "content";
    const res = await updateData(selectionApi, rest, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + selectionContent;
      }, 600);

    }
  };

  return (
    <div>
      <div className="md:pl-8 my-4 mb-8">
        <h1 className="font-oswald font-bold text-xl md:text-2xl -mb-10 uppercase">
          <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new selection
          step
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default SelectionCreate;
